const filteredOrgCoordsQuery = `
  query FilteredOrgCoords($where: Org_coordWhereInput) {
    org_coords(first: 10000, where: $where) {
      edges {
        node {
          objectId
          latitude
          longitude
          org_pointer {
            objectId
            nome
            stato
            tipo_istanza
            indirizzo
            cap
            citta
            nazione
          }
        }
      }
    }
  }
`;

export default filteredOrgCoordsQuery;
